import type { SeoPageModel } from './pageModels';

export const DEFAULT_SEO_IMAGE_PATH = '/assets/brand/deepmox-og-1200x630-v2.png';

export interface SeoPrimaryImageFact {
	url: string;
	width: 1200;
	height: 630 | 675;
}

export function resolveSeoPrimaryImageFact(seo: SeoPageModel): SeoPrimaryImageFact {
	const url = new URL(seo.ogImage ?? DEFAULT_SEO_IMAGE_PATH, seo.canonical);
	return {
		url: url.toString(),
		width: 1200,
		height: url.pathname === DEFAULT_SEO_IMAGE_PATH ? 630 : 675,
	};
}

/** Resolve the single primary image fact shared by HTML head and JSON-LD. */
export function resolveSeoPrimaryImage(seo: SeoPageModel): string {
	return resolveSeoPrimaryImageFact(seo).url;
}

export function buildPrimaryImageObject(seo: SeoPageModel, caption: string) {
	const image = resolveSeoPrimaryImageFact(seo);
	return {
		'@type': 'ImageObject',
		'@id': `${seo.canonical}#primaryimage`,
		url: image.url,
		contentUrl: image.url,
		width: image.width,
		height: image.height,
		caption,
	};
}
